<div [innerHtml]="data" [attr.data-qa]="'wcm-data-container'"></div>